import React from "react";
import { Row, Col } from "reactstrap";
import PropTypes from "prop-types";
import { FormattedDate } from "react-intl";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";

import { CustomFormInput } from "../../../../utils/FormFields";
import translate from "../../../../utils/Translator";

const InvoiceRequest = ({ invoiceRequest }) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Type">{invoiceRequest.InvoiceRequestType}</CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Status">{invoiceRequest.InvoiceRequestStatus}</CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Date">
            <FormattedDate value={`${invoiceRequest.InvoiceRequestDate}T00:00`} />
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label={`${translate("Account")} Name`}>
            {invoiceRequest.InvoiceRequestAccountName}
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label={`${translate("Account")} Number`}>
            {invoiceRequest.InvoiceRequestAccountNumber}
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Execution Date">
            <FormattedDate value={`${invoiceRequest.InvoiceRequestExecutionDate}T00:00`} />
          </CustomFormInput>
        </Col>
        {invoiceRequest.InvoiceRequestAmount && (
          <Col xs={6} md={4} lg={3}>
            <CustomFormInput label="Amount">
              <FormattedNumber value={invoiceRequest.InvoiceRequestAmount} dataTypeDecimalName="currency" />{" "}
              {invoiceRequest.InvoiceRequestCurrencyISO}
            </CustomFormInput>
          </Col>
        )}
      </Row>
      <hr />
    </React.Fragment>
  );
};

export default InvoiceRequest;
